export default "__VITE_ASSET__C5ypt5A2__"